module.exports = __webpack_public_path__ + "img/全景智联大数据平台 V1.0.883adea4.png";